import _implicitStylesheets from "./button.css";
import _implicitScopedStylesheets from "./button.scoped.css?scoped=true";
import _lightningButton from "lightning/button";
import {freezeTemplate, registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, b: api_bind, c: api_custom_element} = $api;
  const {_m0, _m1} = $ctx;
  return [api_custom_element("lightning-button", _lightningButton, {
    className: api_normalize_class_name($cmp.className),
    props: {
      "variant": $cmp.variant,
      "label": $cmp.label,
      "title": $cmp.label,
      "iconName": $cmp.iconName,
      "iconPosition": $cmp.iconPosition,
      "disabled": $cmp.disabled
    },
    key: 0,
    on: {
      "focus": _m0 || ($ctx._m0 = api_bind($cmp.onFocus)),
      "blur": _m1 || ($ctx._m1 = api_bind($cmp.onBlur))
    }
  })];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-1cf87mg47h2";
tmpl.legacyStylesheetToken = "c360-button_button";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
